import React from 'react';

import { ApButtonMain, ApIcon, colors } from '@alixpartners/ui-components';
import {
	DropZoneArea,
	DropZoneText,
	DropWrapper,
	IconWrapper,
	DescriptionText,
	ButtonWrapper,
	StatusText,
	Text,
	TextTruncate,
	ErrorWrapper,
	TextWrapper,
} from './DataUpload.styles';
import { importSpendController } from 'utils/apiRequests';
import Dropzone from 'react-dropzone';
import { ErrorList } from '../ErrorList';
import { bytesToSize } from 'Settings/utils';

export class DataUpload extends React.Component {
	state = {
		isUploading: false,
		isDone: false,
		errors: [],
		fileSize: null,
		fileName: '',
	};
	fileRef = React.createRef();

	onFileSelected = acceptedFiles => {
		const file = acceptedFiles[0];

		this.setState({
			isUploading: true,
			isDone: false,
			fileSize: bytesToSize(file.size),
			fileName: file.name,
			errors: [],
		});

		const formData = new FormData();
		const { isAppend, fetchBudget } = this.props;

		formData.append('file', file);

		importSpendController(formData, isAppend)
			.then(() => {
				this.setState({
					isUploading: false,
					isDone: true,
					errors: [],
				});

				fetchBudget();
			})
			.catch(resp => {
				this.setState({
					errors: resp.errors || ['Unknown error'],
					isUploading: false,
					isDone: false,
				});
			});
	};

	render() {
		const { isUploading, isDone, errors, fileName, fileSize } = this.state;

		if (errors.length > 0) {
			return (
				<ErrorWrapper>
					<IconWrapper>
						<StatusText>The import of the file has failed</StatusText>
					</IconWrapper>
					<DropZoneText>
						<TextWrapper>
							<TextTruncate bold>{fileName}</TextTruncate>
							<Text>&nbsp;({fileSize})</Text>
						</TextWrapper>
					</DropZoneText>
					<ErrorList errors={errors} />
					<ButtonWrapper>
						<Dropzone onDrop={this.onFileSelected} style={{}} noKeyboard>
							{({ getRootProps, getInputProps }) => (
								<div {...getRootProps()}>
									<input {...getInputProps()} accept=".csv" />
									<ApButtonMain iconName="baseline_add">Add file</ApButtonMain>
								</div>
							)}
						</Dropzone>
					</ButtonWrapper>
				</ErrorWrapper>
			);
		}

		return (
			<Dropzone onDrop={this.onFileSelected} style={{}} noKeyboard>
				{({ getRootProps, getInputProps }) => (
					<DropWrapper {...getRootProps()}>
						<input {...getInputProps()} accept=".csv" />

						<DropZoneArea>
							<IconWrapper>
								{isUploading ? (
									<StatusText>File upload is processing...</StatusText>
								) : (
									<ApIcon
										iconName={isDone ? 'cloud_done' : 'cloud_upload'}
										iconSize={64}
										iconColor={colors.grey3}
									/>
								)}
							</IconWrapper>
							<DropZoneText>
								{isUploading ? (
									<TextWrapper>
										<TextTruncate bold>{fileName}</TextTruncate>
										<Text>&nbsp;({fileSize})</Text>
									</TextWrapper>
								) : isDone ? (
									<Text>File was uploaded successfully</Text>
								) : (
									<DescriptionText>
										Drag <span>.csv</span> file here, or browse file to upload
									</DescriptionText>
								)}

								<ButtonWrapper>
									<ApButtonMain iconName="baseline_add" disabled={isUploading}>
										Add file
									</ApButtonMain>
								</ButtonWrapper>
							</DropZoneText>
						</DropZoneArea>
					</DropWrapper>
				)}
			</Dropzone>
		);
	}
}
